import { Dispatch, Store } from "redux";
import { TActionRequest } from "../../base/types/redux";
import MiddlewareRegistry from "../../base/redux/MiddlewareRegistry";
import { apiCreatePayment } from "./services";
import { ACTION_TYPES } from "./actionTypes";
import { setCreatePaymentState } from "./actions";
import { message } from 'antd';

export const middleware =
  ({ dispatch, getState }: Store) =>
  (next: Function) =>
  async (action: TActionRequest<any>) => {
    next(action);
    switch (action.type) {
      case ACTION_TYPES.POST_CREATE_PAYMENT: {
        return await handleCretePayment(dispatch, action, getState);
      }
    }
  };

MiddlewareRegistry.register(middleware);

const handleCretePayment = async (
  dispatch: Dispatch,
  action: TActionRequest<any>,
  getState: () => {  }
) => {
  try {
    const response = await apiCreatePayment(action.params);
    if (response?.status.code === "A200") {
      dispatch(setCreatePaymentState({ isFetching: false, isSuccess: true, data: response.data }));
    } else {
      dispatch(setCreatePaymentState({ isFetching: false, isSuccess: false, data: response.data }));
    }
  } catch (err: any) {
    message.error(err.response?.data.status.message);
    dispatch(setCreatePaymentState({ isFetching: false, isSuccess: false, data: err }));
  }
}